(() => {
  document.querySelectorAll('[data-cb-open-service-reviews]').forEach(button => {
    if (button.dataset.cbBound) return;
    button.dataset.cbBound = 'true';
    button.addEventListener('click', () => {
      const widget = button.closest('.cb-review-banner')?.querySelector('.lipscore-service-review-testimonial-content');
      if (widget) widget.click();
    });
  });
})();
